/**
 * Delayed Tracking Loader
 * Loads non-critical tracking scripts after user interaction to reduce TBT
 * Scripts load on first: scroll, click, touch, or after 5s timeout
 * Uses requestIdleCallback to avoid blocking main thread
 * 
 * Includes: Twitter, Hotjar, TriplePixel, Request Metrics, Northbeam
 */
(function() {
  var loaded = false;

  // Helper to schedule work during idle time
  function scheduleIdle(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 50);
    }
  }

  function loadTrackingScripts() {
    if (loaded) return;
    loaded = true;
    removeListeners();

    // Stagger script loading to reduce main thread blocking
    scheduleIdle(function() {
      loadTriplePixel();
      scheduleIdle(function() {
        loadRequestMetrics();
        scheduleIdle(function() {
          loadNorthbeam();
          scheduleIdle(function() {
            loadTwitter();
            scheduleIdle(loadHotjar);
          });
        });
      });
    });
  }

  function loadTwitter() {
    (function(e,t,n,s,u,a){
      e.twq||(s=e.twq=function(){
        s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,
      u.src='https://static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a));
    })(window,document,'script');
    if (typeof twq !== 'undefined') {
      twq('config','oi0zk');
    }
  }

  function loadHotjar() {
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:3322086,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
  
  function loadTriplePixel() {
    window.TriplePixelData = {
      TripleName: "her-fantasy-box.myshopify.com",
      ver: "2.12",
      plat: "SHOPIFY",
      isHeadless: false
    };
    
    (function(W,H,A,L,E,_,B,N){
      function O(U,T,P,H,R){
        void 0===R&&(R=!1);
        H=new XMLHttpRequest;
        P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0);
        H.send(JSON.stringify(P||{}));
        H.onreadystatechange=function(){
          4===H.readyState&&200===H.status?(R=H.responseText,U.includes(".txt")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))
        }
      }
      if(N=window,!N[H+"sn"]){
        N[H+"sn"]=1;
        L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};
        try{
          A.setItem(H,1+(0|A.getItem(H)||0));
          (E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()});
          A.setItem(H+"U",JSON.stringify(E))
        }catch(e){}
        var i,m,p;
        A.getItem('"!nC`')||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){
          return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)
        },E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,
        O("https://conf.config-security.com/model",5),
        i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),
        p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+":"+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href,ref:document.referrer,ver:A.TriplePixelData.ver},
        O("https://api.config-security.com/event",5,p),
        O("https://whale.camera/live/dot.txt",5)))
      }
    })("","TriplePixel",localStorage);
  }
  
  function loadRequestMetrics() {
    (function(t,e,n,r){
      function a(){return e&&e.now?e.now():null}
      if(!n.version){
        n._events=[];n._errors=[];n._metadata={};n._urlGroup=null;window.RM=n;
        n.install=function(e){
          n._options=e;
          var a=t.createElement("script");a.async=true;a.crossOrigin="anonymous";
          a.src=r;
          var o=t.getElementsByTagName("script")[0];o.parentNode.insertBefore(a,o)
        };
        n.identify=function(t,e){n._userId=t;n._identifyOptions=e};
        n.sendEvent=function(t,e){n._events.push({eventName:t,metadata:e,time:a()})};
        n.setUrlGroup=function(t){n._urlGroup=t};
        n.track=function(t,e){n._errors.push({error:t,metadata:e,time:a()})};
        n.addMetadata=function(t){n._metadata=Object.assign(n._metadata,t)}
      }
    })(document,window.performance,window.RM||{},"https://cdn.requestmetrics.com/agent/current/rm.js");
    
    if (window.RM && window.RM.install) {
      window.RM.install({ token: "k3gg9vg:x7rp7da" });
    }
  }
  
  function loadNorthbeam() {
    (function(){
      var t;
      (n=t=t||{}).A="identify";n.B="trackPageView";n.C="fireEmailCaptureEvent";
      n.D="fireCustomGoal";n.E="firePurchaseEvent";n.F="trackPageViewInitial";
      n.G="fireSlimPurchaseEvent";n.H="identifyCustomerId";
      var n="//j.northbeam.io/ota-sp/e7faaa86-395a-4c0d-841f-2824e3e29fb6.js";
      function r(n){for(var e=[],t=1;t<arguments.length;t++)e[t-1]=arguments[t];a.push({fnName:n,args:e})}
      var e,a=[],i=((e={})[t.F]=function(n){r(t.F,n)},(i={_q:a})[t.A]=function(n,e){return r(t.A,n,e)},
      i[t.B]=function(){return r(t.B)},i[t.C]=function(n,e){return r(t.C,n,e)},
      i[t.D]=function(n,e){return r(t.D,n,e)},i[t.E]=function(n){return r(t.E,n)},
      i[t.G]=function(n){return r(t.G,n)},i[t.H]=function(n,e){return r(t.H,n,e)},
      Object.assign(function(n){for(var e=[],t=1;t<arguments.length;t++)e.push(arguments[t]);return r.apply(null,[n].concat(e))},i));
      window.Northbeam=i;
      (i=document.createElement("script")).async=!0;i.src=n;document.head.appendChild(i);
      e.trackPageViewInitial(window.location.href);
    })();
    
    // Set Northbeam metadata
    if (window.nbRegionCode) {
      localStorage.setItem('nb__region_code', window.nbRegionCode);
    }
    if (window.nbCurrencyCode) {
      localStorage.setItem('nb__currency_code', window.nbCurrencyCode);
    }
  }

  function removeListeners() {
    document.removeEventListener('scroll', loadTrackingScripts);
    document.removeEventListener('click', loadTrackingScripts);
    document.removeEventListener('touchstart', loadTrackingScripts);
    document.removeEventListener('mousemove', loadTrackingScripts);
  }

  // Trigger on user interaction
  document.addEventListener('scroll', loadTrackingScripts, { once: true, passive: true });
  document.addEventListener('click', loadTrackingScripts, { once: true });
  document.addEventListener('touchstart', loadTrackingScripts, { once: true, passive: true });
  document.addEventListener('mousemove', loadTrackingScripts, { once: true, passive: true });

  // Fallback: load after 5 seconds if no interaction (increased from 4s to reduce TBT)
  setTimeout(loadTrackingScripts, 5000);
})();
